import { useState } from 'react'
import { InView } from 'react-intersection-observer'
// Components
import Header from '@/components/newHeader/Header'
import BasicHeadSeo from '@/components/basicHeadSeo'
import PuppyQuiz from '@/components/puppyQuiz'
import Footer from '@/components/newFooter/newFooter'
import Home from '@/components/puppyQuiz/home'
import Button from '@/components/newButton/Button'
import DailyDog from '@/components/home/DailyDog'

import { GET_ALL_LOCATIONS, GET_CATEGORIES, GET_EXPLORE_BREEDS } from '@graphql'

import styles from './quiz.module.scss'
import { ROBOTS_META } from 'const'

export default function BreederLogin({
  breedersLocation,
  categoriesData,
  breedsExplorer,
}) {
  const [initQuiz, setInitQuiz] = useState(false)
  const [isButtonVisible, setIsButtonVisible] = useState(false)
  const [isButtonVisible2, setIsButtonVisible2] = useState(false)
  return (
    <>
      <BasicHeadSeo
        title="Dog Breed Quiz - Which Dog Breed is Right for Me?"
        description="Take our short dog breed quiz to find out what is the best breed for you. Find your match now"
        url={`${process.env.NEXT_PUBLIC_ROOT_URL}/dog-breed-quiz`}
        content={ROBOTS_META}
      />

      <Header />
      {(isButtonVisible || isButtonVisible2) && !initQuiz ? (
        <div className={styles.triggerButton}>
          <Button
            title="Start quiz"
            theme={['pink-solid', 'large']}
            onClick={() => {
              setInitQuiz(true)
              window.scrollTo(0, 0)
            }}
            style={{ width: '340px', margin: '5px 0' }}
          />
        </div>
      ) : null}

      {initQuiz ? (
        <main className={styles.main}>
          <div className={styles.holder}>
            <PuppyQuiz />
          </div>
        </main>
      ) : (
        <main className={styles.main}>
          <div className={styles.holder}>
            <div className={styles.container}>
              <Home
                setInitQuiz={setInitQuiz}
                setIsButtonVisible={setIsButtonVisible}
              />
            </div>
          </div>
          <InView onChange={setIsButtonVisible2}>
            <div className={styles.dailyContainer}>
              <DailyDog
                breedersLocation={breedersLocation}
                categories={categoriesData?.categories}
                breedsExplorer={breedsExplorer}
                puppyQuiz
              />
            </div>
            <Footer />
          </InView>
        </main>
      )}
    </>
  )
}

export async function getStaticProps() {
  const apolloClient = await (
    await import('@/utils/apolloClient')
  ).initializeApollo()
  await import('@/utils/tokenStorage').then((mod) => mod.clearToken())

  let categoriesData
  let explorer
  let locations

  try {
    const { data: _explorer = '' } = await apolloClient.query({
      query: GET_EXPLORE_BREEDS,
    })
    explorer = _explorer
    const { data: _categoriesData = {} } = await apolloClient.query({
      query: GET_CATEGORIES,
    })
    categoriesData = _categoriesData

    const { data: _locations = '' } = await apolloClient.query({
      query: GET_ALL_LOCATIONS,
    })
    locations = _locations
  } catch (error) {
    console.error('BREED QUIZ', error)
  }

  return {
    props: {
      categoriesData,
      breedsExplorer: explorer?.breedsExplorer || null,
      breedersLocation: locations,
    },
    revalidate: 1 * 60 * 60, // Revalidate every hour
  }
}
